import { useQuery } from "@tanstack/react-query"
import { friendsQueryOptions } from "../api/queries"
import { NEW_FRIEND_STATUSES } from "../model/constants"
import type { Friend } from "../model/types"

const selectNewFriendsCount = (friends: Friend[]): number =>
	friends.filter((f) => NEW_FRIEND_STATUSES.has(f.status)).length

// Голый useQuery с select: подписчик ререндерится только при смене счётчика,
// а не на каждый presence-пуш (кэш friendKeys.list переписывается на любой
// онлайн/оффлайн). WS-синком кэша владеет registerFriendSync.
export function useNewFriendsCount(userId: number): number {
	const { data: count = 0 } = useQuery({
		...friendsQueryOptions(userId),
		select: selectNewFriendsCount,
	})

	return count
}
